import { Alert, Stack } from "@mui/material";
import { palette } from "theme";
import CompanyInfoForm from "./components/CompanyInfoForm";
import DetailsStatus from "./components/DetailsStatus";

const InfoTab = () => {
  return (
    <Stack spacing={2}>
      <DetailsStatus />
      <CompanyInfoForm />
      <Alert
        severity='info'
        sx={{
          borderWidth: 1,
          borderStyle: "solid",
          borderColor: palette.blue[100],
          borderRadius: 2,
          alignItems: "center",
          lineHeight: "initial",
          color: palette.primary.main,
          py: 1,
          px: 2.5,
        }}>
        Реквизиты автоподставляются при <b>выставлении счета</b>. Если данные изменятся после формирования счета, старый
        счет не пересчитывается.
      </Alert>
    </Stack>
  );
};

export default InfoTab;
